import { Link } from "react-router-dom";
import { fmtDateTime } from "../lib/format";

function Switch({ on, onToggle }) {
  return (
    <button type="button" className="cr-switch" onClick={() => onToggle(!on)} data-testid={on ? "offer-cr-turn-off" : "offer-cr-turn-on"}>
      {on ? "Slå fra for dette tilbud" : "Slå til igen"}
    </button>
  );
}

export default function CommentReminderBox({ r, onToggle }) {
  if (!r) return null;
  if (r.state === "off")
    return (
      <p className="muted" style={{ margin: "0 0 14px" }} data-testid="offer-cr-off">
        Påmindelse i kommentaren er slået fra – <Link to="/settings">slå til under Indstillinger</Link>
      </p>
    );
  if (r.state === "offer_off")
    return (
      <p className="muted" style={{ margin: "0 0 14px" }} data-testid="offer-cr-offer-off">
        Påmindelse i kommentaren er slået fra for dette tilbud · <Switch on={false} onToggle={onToggle} />
      </p>
    );
  if (r.state === "none")
    return (
      <p className="muted" style={{ margin: "0 0 14px" }} data-testid="offer-cr-none">
        Ingen påmindelse i kommentaren for dette tilbud
      </p>
    );
  if (r.state === "planned")
    return (
      <div className="notice" data-testid="offer-comment-reminders">
        <b>Påmindelse i kommentaren sendes:</b> <span data-testid="offer-cr-when">{fmtDateTime(r.send_at)}</span> til{" "}
        <span data-testid="offer-cr-n">{r.n} {r.n === 1 ? "kunde" : "kunder"}</span>, der ikke har hentet endnu
        {r.preview_blocked ? <span className="muted"> (sendes ikke i preview)</span> : null} · <Switch on onToggle={onToggle} />
      </div>
    );
  return (
    <div className="notice" data-testid="offer-comment-reminders">
      <b>Påmindelser i kommentaren:</b>{" "}
      {r.sent_at ? <><span data-testid="offer-cr-sent-at">Sendt {fmtDateTime(r.sent_at)}</span> · </> : null}
      <span data-testid="offer-cr-sent">{r.sent} sendt</span> · <span data-testid="offer-cr-picked">{r.picked_after} hentet bagefter</span>
      {r.queued ? <> · <span data-testid="offer-cr-queued">{r.queued} i kø</span></> : null}
      {r.failed ? <> · <span data-testid="offer-cr-failed">{r.failed} kunne ikke sendes</span></> : null}
    </div>
  );
}
